import(/* webpackMode: "eager" */ "/home/ubuntu/projects/shopryze/os-storefront-blue/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/app/ClientBody.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/app/globals.css");
